import { createFileRoute } from '@tanstack/react-router';

import { UsersPage } from '@/features/members/pages/UsersPage';

export const Route = createFileRoute('/_authenticated/users')({
  component: UsersPage,
  beforeLoad: () => ({
    breadcrumbs: [{ title: 'Users', href: '/users' }],
  }),
});
